import React from 'react';

const Clock = (props) => (
  <svg role="img" aria-label="Clock icon" viewBox="0 0 80 80" {...props}>
    <path d="M40 0a40 40 0 1040 40A40 40 0 0040 0zm16.73 56.5a3.87 3.87 0 01-2.8 1.15 3.7 3.7 0 01-2.61-1.08L35.43 41.1V20.24a3.83 3.83 0 017.65 0v17.63l13.58 13.22a3.83 3.83 0 01.06 5.41z" />
  </svg>
);

export default Clock;
